import { render, staticRenderFns } from "./KakaoAuthority.vue?vue&type=template&id=1d092f5c&scoped=true"
import script from "./KakaoAuthority.vue?vue&type=script&lang=js"
export * from "./KakaoAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d092f5c",
  null
  
)

export default component.exports